import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import { BlockType } from '../../../types/api/ElementType';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import {
  BlockInteractions,
  DISPLAY_TYPE,
  createButtonObject,
  Views as BlockInteractionsViews,
} from '../../../components/organisms/BlockInteractions';
import {
  CollapsibleContainerBlockDefault,
  CollapsibleContainerBlockDefaultView,
} from '../views/CollapsibleContainerBlockDefaultView';
import { useContentWrapperContext } from '../../../components/blocks/ContentWrapper/ContentWrapperContext';
import { useContentWrapperDndContext } from '../../../components/blocks/ContentWrapper/ContentWrapperDndProvider';
import { CollapsibleContainerBlockEditView } from '../views/CollapsibleContainerBlockEditView';
import { DefaultView, OptionalEditView, Views } from '../../../types/BlockWithViews';
import { headlineHierarchy } from '../../../components/organisms/BlockInteractions/BlockInteractions.utils';

export type CollapsibleContainerBlockProps = Views<
  DefaultView<CollapsibleContainerBlockDefaultView> & OptionalEditView<CollapsibleContainerBlockEditView>
>;

export function CollapsibleContainerBlockInteractions({
  views,
  activeView = 'default',
}: CollapsibleContainerBlockProps) {
  const { t } = useSonTranslation('CollapsibleContainerBlock');
  const { uuid } = useBlockContext();
  const { refreshCount } = useRefreshBlock();

  const contentWrapperContext = useContentWrapperContext();
  const contentWrapperDndContext = useContentWrapperDndContext();

  const buttons = views.edit
    ? createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        'CollapsibleContainerBlock:edit',
        DISPLAY_TYPE.COLLAPSIBLE,
        <CollapsibleContainerBlockEditView {...views.edit} />
      )
    : {};

  return (
    <BlockInteractions
      refreshCount={refreshCount}
      contentWrapperContext={contentWrapperContext}
      contentWrapperDndContext={contentWrapperDndContext}
      uuid={uuid}
      elementType={BlockType.collapsiblecontainer}
      headline={{
        text: t('edit.heading'),
        hierarchy: headlineHierarchy(2, contentWrapperContext?.parentIndex, contentWrapperContext?.grandParentIndex),
        visible: true,
      }}
      activeView={activeView}
      views={views}
      buttons={buttons}
    >
      <CollapsibleContainerBlockDefault views={views} />
    </BlockInteractions>
  );
}
